// extracted by mini-css-extract-plugin
module.exports = {"qNaContaienr":"J_Zt13NmDbsSfOMKEKzSm","qnaText":"_3W8DbeaR7Avl3wCb2biAg7"};